<script>
import productComponent from '../product/product.vue';

export default {
  data() {
    return {
      goingToShipped: false,
    };
  },
  props: ['box'],
  computed: {
    quantity() {
      if (typeof this.box === 'undefined') return false;

      return this.box.products.reduce((accumulator, currentValue) => (
        accumulator + currentValue.quantity
      ), 0);
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
  },
  components: {
    product_component: productComponent,
  },
};
</script>
<template src="./box.pug" lang="pug"></template>
